<template>
  <div :class="classObj" class="app-wrapper">
    <sidebar class="sidebar-container" />
    <div :class="{ hasTagsView: needTagsView }" class="main-container">
      <div :class="{ 'fixed-header': fixedHeader }" class="flexBet">
        <navbar :adminMessageTotal="adminMessageTotal" />
      </div>
      <app-main />
    </div>
    <PhoneDrawer ref="PhoneDrawer" />
    <VideoTutorials ref="VideoTutorials" />
    <SystemNotification ref="SystemNotification" />
    <record ref="record"></record>
  </div>
</template>

<script>
import { AppMain, Sidebar, Navbar } from './components'
import PhoneDrawer from './components/PhoneDrawer'
import VideoTutorials from './components/videoTutorials'
import SystemNotification from './components/systemNotification'
import { getToken } from '@/utils/auth'
import { baseURLWSS } from '@/api/getFile'
import { adminMessageUpd, myAdminMessageCount } from '@/api/adminMessage'
import record from '@/components/record'

export default {
  name: 'Layout',
  components: {
    Sidebar,
    AppMain,
    PhoneDrawer,
    VideoTutorials,
    SystemNotification,
    Navbar,
    record,
  },
  data() {
    return {
      websocket: '',
      isConnect: false,
      heartTime: null,
      adminMessageTotal: 0,
      show: true,
    }
  },
  provide() {
    return {
      indexThis: this,
    }
  },
  computed: {
    sidebar() {
      return this.$store.state.app.sidebar
    },
    fixedHeader() {
      return this.$store.state.settings.fixedHeader
    },
    needTagsView() {
      return this.$store.state.settings.tagsView
    },

    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
      }
    },
  },
  created() {
    if (getToken()) this.$store.dispatch('user/getSealConfig')
    if (this.$store.getters.organizationInfo.organizationType !== 2) this.init()
    this.$store.dispatch('user/getSubsidiaryDropLists')
    this.myAdminMessageCount()

    // 模拟客服电话弹窗
    // this.$nextTick(() => {
    //   this.$refs.PhoneDrawer.popupSetting({
    //     onlineState: 2,
    //     userPhoneNumber: 15295910232,
    //   })
    // })
  },
  destroyed() {
    clearInterval(this.heartTime)
    if (this.websocket) this.websocket.close(), (this.isConnect = false)
  },
  methods: {
    async myAdminMessageCount() {
      const { data: res } = await myAdminMessageCount({ readState: 1, fromBackend: 1 })
      this.adminMessageTotal = parseInt(res)
    },

    init() {
      if (!getToken()) {
        this.lapseLogin()
        return this.$message.error('登录已失效，请重新登录')
      }
      const hostname = window.location.hostname === 'localhost' ? baseURLWSS : 'wss://' + window.location.hostname
      this.websocket = new WebSocket(`${hostname}/wss/message/${getToken()}`)
      this.messagePopup()
    },
    async lapseLogin() {
      await this.$store.dispatch('user/resetToken')
      this.$router.push('/login')
    },
    messagePopup() {
      this.websocket.onopen = e => {
        this.isConnect = true
        this.heartStart()
        //
      }
      this.websocket.onmessage = e => {
        //
        this.heartReset()
        if (e.data) {
          const data = JSON.parse(e.data.replace(/\"id\":(\d+)/, '"id": "$1"').replace(/\"applyOverviewId\":(\d+)/, '"applyOverviewId": "$1"'))
          const messageData = data.data

          const errCode = JSON.parse(e.data).errCode
          if (errCode === 1030 || errCode === 1011 || errCode === 1001) {
            this.isConnect = false
            clearInterval(this.heartTime)
            this.websocket.close()
            this.lapseLogin()
            return this.$message.error('登录已失效，请重新登录')
          } else if (JSON.parse(e.data).errCode === 503 || JSON.parse(e.data).errCode === 502 || JSON.parse(e.data).errCode === 500) {
            return this.$router.replace('/error')
          }
          // 消息通知
          if (data.messageType === 1) {
            if (!messageData.messageType) return
            if (messageData.messageType === 6 || messageData.messageType === 0 || messageData.messageType === 7 || messageData.messageType === 16) return
            if (!getToken()) return
            const audio = document.createElement('audio')
            audio.setAttribute('src', `${this.imgStaticUrl}/messageAudio/${messageData.messageType}.WAV`)
            audio.play()
            this.myAdminMessageCount()
            let notify = this.$notify({
              title: '提示',
              message: messageData.messageContent,
              duration: 0,
              type: 'warning',
            })
            notify.onClick = () => {
              let routerPath = this.dictType('adminMessageEnumArr', messageData.messageType, 'path')
              if (messageData.messageType === 18 || messageData.messageType === 19 || messageData.messageType === 49 || messageData.messageType === 50)
                routerPath = `${routerPath}?applyOverviewId=${messageData.applyOverviewId}&messageType=${messageData.messageType}`
              const startIndex = routerPath.indexOf('/') + 1 // 第一个斜杠的索引加 1
              const endIndex = routerPath.indexOf('/', startIndex) // 第二个斜杠的索引
              let betweenSlashes
              if (startIndex !== -1 && endIndex !== -1) {
                betweenSlashes = routerPath.substring(startIndex, endIndex)
              }
              this.$store.dispatch('permission/findIndexByPath', betweenSlashes)
              routerPath === this.$route.fullPath
                ? this.$nextTick(() => {
                    this.$router.replace({
                      path: '/redirect' + this.$route.fullPath,
                    })
                  })
                : this.$router.push(routerPath)
              adminMessageUpd({ id: messageData.id, readState: 2 })
              setTimeout(() => {
                notify.close()
              }, 1000)
            }
          }
          // 客服弹窗
          if (data.messageType === 2) {
            this.$refs.PhoneDrawer.popupSetting(messageData)
          }
        }
      }
      this.websocket.onclose = e => {
        if (!this.isConnect) return
        setTimeout(() => {
          this.init()
        }, 1000)
      }
      this.websocket.onerror = e => {}
    },
    heartStart() {
      clearInterval(this.heartTime)
      this.heartTime = setInterval(() => {
        if (this.websocket.readyState === 1) {
          this.websocket.send(
            JSON.stringify({
              chatType: 'hert',
              content: 'pong',
              contentType: 'hert',
            })
          )
        } else {
          this.isConnect = true
          this.websocket.close()
        }
      }, 5000)
    },
    heartReset() {
      clearInterval(this.heartTime)
      //重启心跳
      this.heartStart()
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~@/styles/mixin.scss';
@import '~@/styles/variables.scss';

.flexBet {
  display: flex;
  justify-content: space-between;
}

.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;

  &.mobile.openSidebar {
    position: fixed;
    top: 0;
  }

  &-title {
    width: 100%;
    height: 38px;
    background: #13225a;
    color: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;
  }

  .logo {
    font-size: 20px;
    margin-left: 10px;
    display: inline-block;
  }

  .titleRight {
    font-size: 14px;

    & span:first-child {
      margin-right: 15px;
      color: #fff;
    }
  }
}

.fixed-header {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 9;
  width: calc(100% - #{$sideBarWidth});
  transition: width 0.28s;
}

.hideSidebar .fixed-header {
  width: calc(100% - 54px);
}

.mobile .fixed-header {
  width: 100%;
}

::v-deep .tags-view-container {
  max-width: 77% !important;
}
</style>
